<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="50%"
            height="100%"
            class="modalDialog"
            no-click-animation
            >
            <v-card class="pa-3">
                <CardTitle :title="page_title" />
                    <v-container>
                        <v-row class="pa-2 h-75">
                            <p>{{ receivedGolfCourseName }}</p>
                        </v-row>
                        <v-row class="pa-2 h-75">
                            <p>{{ propsPlanName }}</p>
                        </v-row>
                    </v-container>
                    <v-form
                        ref="form"
                    >
                        <v-row class="h-75">
                            <v-col cols="4">
                                <v-radio-group v-model="input.radio">
                                    <v-radio
                                        value="1"
                                        label="総額（税込）"
                                    />
                                </v-radio-group>
                            </v-col>
                            <v-col>
                                <!-- <v-text-field
                                    class="px-3"
                                    maxlength="8"
                                    type="number"
                                    :value="calcTotalFee"
                                    @input="input.totalFee = $event"
                                    :rules='[rules.numberOnly]'
                                    :disabled="input.radio === '2'"
                                /> -->
                                <v-text-field
                                    class="px-3"
                                    maxlength="10"
                                    inputmode="tel"
                                    :value="input.totalFee.toLocaleString()"
                                    @input="input.totalFee = $event"
                                    v-on:focus="input.totalFee = formatFoucsFee(input.totalFee)"
                                    v-on:blur="input.totalFee = formatBlurFee(input.totalFee)"
                                    :rules='[rules.correctFee]'
                                    :disabled="input.radio === '2'"
                                />
                            </v-col>
                            <v-col class="align-self-center">
                                円
                            </v-col>
                        </v-row>
                        <v-row class="h-75">
                            <v-col cols="4">
                                <v-radio-group v-model="input.radio">
                                    <v-radio
                                        value="2"
                                        label="料金（税抜）"
                                    />
                                </v-radio-group>
                            </v-col>
                            <v-col>
                                <!-- <v-text-field
                                    class="px-3"
                                    maxlength="8"
                                    type="number"
                                    :value="calcBaseFee"
                                    @input="input.baseFee = $event"
                                    :rules='[rules.numberOnly]'
                                    :disabled="input.radio === '1'"
                                /> -->
                                <v-text-field
                                    class="px-3"
                                    maxlength="10"
                                    inputmode="tel"
                                    :value="input.baseFee.toLocaleString()"
                                    @input="input.baseFee = $event"
                                    v-on:focus="input.baseFee = formatFoucsFee(input.baseFee)"
                                    v-on:blur="input.baseFee = formatBlurFee(input.baseFee)"
                                    :rules='[rules.correctFee]'
                                    :disabled="input.radio === '1'"
                                />
                            </v-col>
                            <v-col class="align-self-center">
                                円
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row class="h-75">
                        <v-col cols="4" class="blockCenter">
                            {{taxSalesName}}
                        </v-col>
                        <v-col>
                            <!-- <p>{{calcTaxSales}}</p> -->
                            {{displayTaxSales.toLocaleString()}} 円
                        </v-col>
                    </v-row>
                    <v-row v-if="taxUsageName" class="h-75">
                        <v-col cols="4" class="blockCenter">
                            {{taxUsageName}}
                        </v-col>
                        <v-col>
                            <v-select
                                :items="taxUsageSelection"
                                item-value="tax"
                                item-text="textTax"
                                v-model="input.taxUsage"
                                dense
                                />
                            <!-- <p>{{Number(displayTaxUsage)}}</p> -->
                        </v-col>
                        <v-col class="align-self-center">
                            円
                        </v-col>
                    </v-row>
                    <v-row v-if="taxOthersName" class="h-75">
                        <v-col cols="4" class="blockCenter">
                            {{taxOthersName}}
                        </v-col>
                        <v-col>
                            <v-select
                                :items="taxOthersSelection"
                                item-value="tax"
                                item-text="textTax"
                                v-model="input.taxOthers"
                                dense
                                />
                            <!-- <p>{{Number(displayTaxOthers)}}</p> -->
                        </v-col>
                         <v-col class="align-self-center">
                            円
                        </v-col>
                    </v-row>
                    <div class="red--text h-75">
                        ※税金はプラン作成日を基準に取得します。<br>
                        データが取得されない場合は、プラン用マスタ管理から税関連の日付を確認してください。
                    </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                    <v-btn color="green darken-4" v-if="modeStatus === 'addMode'" text @click="displayAddOverLay">登録</v-btn>
                    <v-btn color="green darken-4" v-if="modeStatus === 'changeMode'" text @click="displayChangeOverLay">変更</v-btn>
                </v-card-actions>
                <AddOverLay
                    page-name="料金"
                    @processing="registPlanFee"
                    @cancel="closeAddOverLay"
                    :process-result="process"
                    :OverlaySwitch="addOverlay"
                />
                <changeOverLay
                    page-name="料金"
                    @processing="updatePlanTime"
                    @cancel="closeChangeOverLay"
                    :process-result="process"
                    :OverlaySwitch="changeOverlay"
                />
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import { utilityMixin } from '@/mixins/utility';
import {
    GET_TAX,
    REGIST_PLAN_FEE,
    UPDATE_PLAN_FEE } from '@/constants/plan';
import AddOverLay from '@/components/overlay/AddOverlay';
import changeOverLay from '@/components/overlay/ChangeOverlay';
import validater from '@/lib/validater';

export default {
    components: {
        CardTitle,
        AddOverLay,
        changeOverLay
    },
    mixins: [
        utilityMixin
    ],
    props: [
        'feeID',
        'dialog',
        'receivedGolfCourse',
        'receivedGolfCourseName',
        'propsCourse',
        'propsPlanId',
        'propsPlanName',
        'modeStatus',
        'received',
        'propsPlanStart',
        'propsPlanEnd'
    ],
    data () {
        return {
            // 追加確認用ポップアップ表示に関する制御値
            addOverlay: false,
            changeOverlay: false,
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // 入力値
            input: {
                radio: '2',
                courseValue: '',
                taxSales: 0,
                totalFee: 0,
                baseFee: '',
                taxUsage: '',
                taxOthers: ''
            },
            Now: '',
            End: '',
            taxSalesName: '',
            taxUsageName: '',
            taxOthersName: '',
            displayTaxSales: '0',
            displayTaxUsage: '',
            displayTaxOthers: '',
            taxUsageSelection: [],
            taxOthersSelection: [],
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: '料金情報',
            rules: {
                // 必須項目
                required: value => !!value || this.$t('error.validation.required.any'),
                // 氏名（姓）バリデーション
                // correctDate: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct'),
                formatedFee: value => validater.checkNum(value) || this.$t('error.validation.fee'),
                correctTime: value => this.timeCorrected(value) || this.$t('error.validation.time.correct'),
                correctFee: value => validater.checkFeeType(value) || this.$t('error.validation.required.incorrect')
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '001', element_name: '追加', isActive: true },
                { element_id: '002', element_name: '変更', isActive: true },
                { element_id: '003', element_name: '削除', isActive: true }
            ],
            vue_id: '',
            taxationSelection: [
                { code: '1', code_name: '全て' },
                { code: '2', code_name: '消費税だけ' }
            ]
        };
    },
    watch: {
        input: {
            handler (val) {
                if (val.radio === '1') {
                    this.calc();
                } else {
                    this.calc();
                }
            },
            deep: true
        },
        async propsPlanId () {
            if (this.propsPlanId !== '') {
                const dtStart = new Date(this.propsPlanStart);
                const dtEnd = new Date(this.propsPlanEnd);
                const startMonth = String(dtStart.getMonth() + 1).padStart(2, '0');
                const startDate = String(dtStart.getDate()).padStart(2, '0');
                const endMonth = String(dtEnd.getMonth() + 1).padStart(2, '0');
                const endDate = String(dtEnd.getDate()).padStart(2, '0');
                this.Now = await dtStart.getFullYear() + '-' + startMonth + '-' + startDate;
                this.End = await dtEnd.getFullYear() + '-' + endMonth + '-' + endDate;
                this.getTax();
            }
        },
        received: {
            handler () {
                this.input.baseFee = this.formatFee(this.received.baseFee);
                this.input.totalFee = this.formatFee(this.received.totalFee);
                this.input.displayTaxSales = this.received.displayTaxSales;
            },
            deep: true
        }
    },
    // computed: {
    //     formatedTotalFee () {
    //         return Number(this.input.totalFee).toLocaleString();
    //     },
    //     formatedBaseFee () {
    //         return Number(this.input.baseFee).toLocaleString();
    //     },
    //     formatedTaxSales () {
    //         return Number(this.displayTaxSales).toLocaleString();
    //     },
    //     formatedTaxUsage () {
    //         return this.input.taxUsage.toLocaleString();
    //     },
    //     formatedTaxOthers () {
    //         return this.input.taxOthers.toLocaleString();
    //     }
    // },
    methods: {
        calc () {
            const totalFee = typeof this.input.totalFee === 'string' ? Number(this.input.totalFee.replace(/,/g, '')) : this.input.totalFee;
            const baseFee = typeof this.input.baseFee === 'string' ? Number(this.input.baseFee.replace(/,/g, '')) : this.input.baseFee;
            const taxSales = typeof this.taxSales === 'string' ? Number(this.taxSales) : this.taxSales;
            const taxUsage = typeof this.input.taxUsage === 'string' ? Number(this.input.taxUsage.replace(/,/g, '')) : this.input.taxUsage;
            const taxOthers = typeof this.input.taxOthers === 'string' ? Number(this.input.taxOthers.replace(/,/g, '')) : this.input.taxOthers;
            if (this.input.radio === '1') {
                let BaseFeeTmp = (totalFee - taxUsage - taxOthers) / (1 + taxSales * 0.01);
                let taxSalesAmount = (totalFee - taxUsage - taxOthers) - BaseFeeTmp;
                taxSalesAmount = Math.floor(taxSalesAmount);
                this.displayTaxSales = taxSalesAmount < 0 ? 0 : taxSalesAmount;
                let BaseFeeReal = (totalFee - taxUsage - taxOthers) - taxSalesAmount;
                this.input.baseFee = BaseFeeReal < 0 ? 0 : BaseFeeReal;
            } else if (this.input.radio === '2') {
                let taxSalesAmount = baseFee * taxSales * 0.01;
                taxSalesAmount = Math.floor(taxSalesAmount);
                this.displayTaxSales = taxSalesAmount < 0 ? 0 : taxSalesAmount;
                const totalFee = baseFee + taxSalesAmount + taxUsage + taxOthers;
                this.input.totalFee = totalFee < 0 ? 0 : totalFee;
            }
        },
        Initialize () {
            this.$set(this.input, 'taxSales', 0);
            this.$set(this.input, 'totalFee', 0);
            this.$set(this.input, 'baseFee', 0);
            this.$set(this.received, 'displayTaxSales', 0);
            this.$set(this.received, 'totalFee', 0);
            this.$set(this.received, 'baseFee', 0);
            this.$set(this.input, 'radio', '2');
            this.displayTaxSales = 0;
        },
        /** ----------------------------------------------
         * 終了時刻が開始時刻より大きい
         * ---------------------------------------------- */
        timeCorrected () {
            if (this.input.startTime && this.input.endTime) {
                return Number(this.input.startTime.replace(/:/g, '')) < Number(this.input.endTime.replace(/:/g, ''));
            }
        },
        /** ----------------------------------------------
         * 登録処理
         * ---------------------------------------------- */
        registPlanFee () {
            var totalFee = typeof this.input.totalFee === 'string' ? Number(this.input.totalFee.replace(/,/g, '')) : this.input.totalFee;
            var baseFee = typeof this.input.baseFee === 'string' ? Number(this.input.baseFee.replace(/,/g, '')) : this.input.baseFee;
            this.$apollo.mutate({
                mutation: REGIST_PLAN_FEE,
                variables: {
                    plan_id: this.propsPlanId,
                    total_fee: totalFee,
                    base_fee: baseFee,
                    tax_sales: this.displayTaxSales,
                    tax_usage: this.input.taxUsage,
                    tax_others: this.input.taxOthers
                }
            }).then(res => {
                const data = res.data.registPlanFee.result;
                if (data === 1) {
                    this.closeAddOverLay();
                    this.CloseModal();
                } else if (data === 0) {
                    const resultText = '同じ金額が登録されています。';
                    throw new Error(resultText);
                }
            }).catch(error => {
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', error);
            });
        },
        /** ----------------------------------------------
         * 登録処理
         * ---------------------------------------------- */
        updatePlanTime () {
            var totalFee = typeof this.input.totalFee === 'string' ? Number(this.input.totalFee.replace(/,/g, '')) : this.input.totalFee;
            var baseFee = typeof this.input.baseFee === 'string' ? Number(this.input.baseFee.replace(/,/g, '')) : this.input.baseFee;
            this.$apollo.mutate({
                mutation: UPDATE_PLAN_FEE,
                variables: {
                    plan_id: this.propsPlanId,
                    total_fee: totalFee,
                    base_fee: baseFee,
                    tax_sales: this.displayTaxSales,
                    tax_usage: this.input.taxUsage,
                    tax_others: this.input.taxOthers,
                    fee_id: this.feeID
                }
            }).then(res => {
                const data = res.data.updatePlanFee.result;
                if (data === 1) {
                    this.closeChangeOverLay();
                    this.CloseModal();
                } else if (data === 0) {
                    const resultText = '同じ金額が登録されています。';
                    throw new Error(resultText);
                }
            }).catch(error => {
                error = error.message.split(/:/g);
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', error[1]);
            });
        },
        /** ----------------------------------------------
         * 税金を取得
         * ---------------------------------------------- */
        getTax () {
            return this.$apollo.query({
                query: GET_TAX,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.receivedGolfCourse,
                    start_date: this.Now,
                    end_date: this.End
                }
            }).then(res => {
                const data = res.data.getPlanTax;
                // 消費税
                this.taxSales = data[0].tax_array[0];
                this.taxSalesName = data[0].tax_name;
                // 利用税
                this.taxUsageSelection = [];
                for (let taxUsage of data[1].tax_array) {
                    var list = {
                        textTax: this.formatFee(taxUsage),
                        tax: taxUsage
                    };
                    this.taxUsageSelection.push(list);
                }
                this.input.taxUsage = data[1].tax_array[0];
                this.taxUsageName = data[1].tax_name;
                // その他諸経費
                this.taxOthersSelection = [];
                for (let taxOther of data[2].tax_array) {
                    var Otherslist = {
                        textTax: this.formatFee(taxOther),
                        tax: taxOther
                    };
                    this.taxOthersSelection.push(Otherslist);
                }
                this.input.taxOthers = data[2].tax_array[0];
                this.taxOthersName = data[2].tax_name;
            });
        },
        /** ----------------------------------------------
         * モーダル画面を表示する処理
         * ---------------------------------------------- */
        displayAddOverLay () {
            this.addOverlay = true;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる処理
         * ---------------------------------------------- */
        closeAddOverLay () {
            this.addOverlay = false;
            this.$set(this.process, 'result', '');
            this.$set(this.process, 'resultText', '');
        },
        /** ----------------------------------------------
         * モーダル画面を表示する処理
         * ---------------------------------------------- */
        displayChangeOverLay () {
            this.changeOverlay = true;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる処理
         * ---------------------------------------------- */
        closeChangeOverLay () {
            this.changeOverlay = false;
            this.$set(this.process, 'result', '');
            this.$set(this.process, 'resultText', '');
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.Initialize();
            this.$emit('close');
        }
    }
};
</script>

<style scoped>

    .v-text-field ::v-deep input[type=number]::-webkit-outer-spin-button,
    .v-text-field ::v-deep input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .v-text-field ::v-deep input[type=number] {
        -moz-appearance: textfield;
    }

    .blockCenter{
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
